export const EASE: [number, number, number, number] = [0.16, 1, 0.3, 1];

export const MONTH_NAMES = [
  "JANUARY","FEBRUARY","MARCH","APRIL","MAY","JUNE",
  "JULY","AUGUST","SEPTEMBER","OCTOBER","NOVEMBER","DECEMBER",
];

export const DAY_LABELS = ["S","M","T","W","T","F","S"];

export const EVENT_COLORS = [
  "#1a7aff", // Blue
  "#8b5cf6", // Purple
  "#ec4899", // Pink
  "#10b981", // Emerald
  "#f97316", // Orange
  "#0ea5e9", // Sky
  "#f43f5e", // Rose
];

export const ROADMAP_INDICATOR_COLOR = "#1a7aff";

export const CALENDAR_GRID_VARIANTS = {
  enter: { opacity: 0, scale: 0.98 },
  center: { opacity: 1, scale: 1, transition: { duration: 0.3, ease: EASE } },
  exit: { opacity: 0, scale: 0.98, transition: { duration: 0.2, ease: EASE } },
};
